<div class="subBlockContainer" id="createcirrustenant">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      <div [formGroup]="userFormGroup">
        <div class="container" formGroupName="userGroup">
          <div class="row">
            <div class="userinfo col-md-6">
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="firstNameValidate" formControlName="firstNameField" placeholder="FIRST NAME" 
                  required>
                 
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="lastNameValidate" formControlName="lastNameField" placeholder="LAST NAME" required>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="companyNameValidate" formControlName="companyNameField" placeholder="COMPANY NAME"
                  required>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="companyDescValidate" formControlName="companyDescField"  placeholder="COMPANY DESCRIPTION"
                  required>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="emailValidate" formControlName="emailField" placeholder="EMAIL"  required>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput (keypress)="isNumberKey($event)" class="phoneValidate" formControlName="phoneField" value ="0000000000"
                  placeholder="PHONE" required>
              </mat-form-field>
            </div>

            <div class="userinfo col-md-6">
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="addressLine1Validate" formControlName="addressLine1Field"
                  placeholder="ADDRESS LINE 1"  required>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="addressLine2Validate" formControlName="addressLine2Field"
                  placeholder="ADDRESS LINE 2">
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="addressLine3Validate" formControlName="addressLine3Field"
                  placeholder="ADDRESS LINE 3">
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="suburbValidate" #myAutocompleteTriggerSub="matAutocompleteTrigger"
                  [matAutocomplete]="autoSuburb" formControlName="suburbField" placeholder="SUBURB"
                  (suburb)="startFilterSub($event)" (input)="onInputSub($event)" (keydown.Tab)="chooseAutoCompletSuburb($event)"
                  required>
                <mat-autocomplete #autoSuburb="matAutocomplete">
                  <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
                    (click)="chooseAutoComplete(option)">
                    {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <mat-select class="stateValidate" placeholder="State" formControlName="stateField" required>
                  <mat-option value="{{state}}" *ngFor="let state of stateList">{{state}}</mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <ng-select style="margin-top: 30px;" class="customDropdwon stateValidate" [items]="stateList" bindValue="state" bindLabel="state"
                placeholder="State *" formControlName="stateField"></ng-select> -->
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="postcodeValidate" #myAutocompleteTriggerPostcode="matAutocompleteTrigger"
                  maxlength="4" (keypress)="isNumberKey($event)" formControlName="postcodeField"
                  (input)="onInputPostcode($event)" (postcode)="startFilterPostcode($event)"
                  (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                  placeholder="POST CODE" required>
                <mat-autocomplete #autoPostcode="matAutocomplete">
                  <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
                    (click)="chooseAutoComplete(option)">
                    {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

            </div>
          </div>
        </div>
      </div>
      <div class="button-center">
          <button class="button button-red button-large" (click)="saveEndUser()"
                  [disabled]="!(user$|async)?.hasAdminAccess && !(user$|async)?.hasPurchaseAccess"
                  [matTooltipDisabled]="(user$|async)?.hasAdminAccess || (user$|async)?.hasPurchaseAccess"	
                  matTooltip="Requires Purchasing Permissions"
          >Create End User Subscription</button>
      </div>
      <loading-screen *ngIf="!loadContent" [isChildLoader]="true" [showBlurTable]="false"></loading-screen>
      </div>
    </div>
  </div>
</div>